import React from "react";
import { FrameContext } from "../contexts/FrameContext";
import useTranslations from "./useTranslations";
import dateHelpers from "../helpers/dateHelpers";

const useScheduleDay = (date) => {
    const {settings} = React.useContext(FrameContext);
    let content = useTranslations().dates;

    if (!date) return null;

    const day = (date, d) => {
        if (dateHelpers.isToday(date)) return content.today;
        if (dateHelpers.isTomorrow(date)) return content.tomorrow;

        return content.daysOfWeek[d];
    }

    const month = m => {
        return content.months[m];
    }

    let today = date || new Date();
    return `${day(today, today.getDay())}, ${month(today.getMonth())} ${today.getDate()}${settings && settings.lang === "ja" ? "日" : ""}`
}

export default useScheduleDay;